import axios from 'axios'

/**
 * Gestores que puede ofrecer el filtro `Gestor` de la tabla de solicitudes.
 *
 * La API decide el alcance según el rol: el perfil responsable recibe todos los
 * gestores con solicitudes, un gestor solo a sí mismo y un cliente únicamente
 * los gestores de sus propias solicitudes.
 */
export const fetchRequestManagers = async () => {
  const token = localStorage.getItem('token')
  if (!token) return []

  const response = await axios.get(
    `${import.meta.env.VITE_API_URL}/request/filters/managers`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  )

  const managers = response.data?.value?.gestores

  return Array.isArray(managers) ? managers : []
}
